/**
 * Sidebar に表示するメニュー定義
 */
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import PostAddIcon from "@mui/icons-material/PostAdd";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";

export const SIDEBAR_MENUS = [
  // ===== 固定メニュー =====
  {
    label: "マイページ",
    path: "/skill_sheets",
    icon: HomeOutlinedIcon,
    type: "static",
    visibleFor: ["user", "company_employee"],
  },
  {
    label: "基本情報",
    path: "/skill_sheet_basics/edit",
    icon: PersonAddIcon,
    type: "static",
    visibleFor: ["user", "company_employee"],
  },
  {
    label: "自己評価",
    path: "/skill_sheet_self_evaluations/edit",
    icon: MilitaryTechIcon,
    type: "static",
    visibleFor: ["user", "company_employee"],
  },
  {
    label: "プロジェクト追加",
    path: "/skill_sheet_mains/new",
    icon: PostAddIcon,
    type: "static",
    visibleFor: ["user", "company_employee"],
  },

  // ===== 参画プロジェクト（動的）=====
  {
    label: "参画プロジェクト",
    icon: GroupsOutlinedIcon,
    type: "dynamic", // 動的に子要素を持つ
    key: "work_histories", // どのデータを使うか識別するキー
    visibleFor: ["user", "company_employee"],
  },

  // ===== 探す系 =====
  {
    label: "プロジェクトを探す",
    path: "/projects",
    icon: FindInPageIcon,
    type: "static",
    visibleFor: ["user"],
  },
  {
    label: "求人を探す",
    path: "/jobs",
    icon: BusinessCenterOutlinedIcon,
    type: "static",
    visibleFor: ["user"],
    redirectRule: {
      key: "jobRequestCreated",
      redirectTo: "/user_job_request/edit",
    },
  },

  // ===== お役立ち情報（外部リンク）=====
  {
    label: "お役立ち情報",
    path: "https://skilllog.jp/blog/",
    icon: InfoOutlinedIcon,
    type: "static",
    external: true,
    visibleFor: ["user"],
  },

  // ===== LINE 登録 =====
  {
    label: "LINE登録はこちら",
    path: "https://lin.ee/Cl1hudR",
    icon: ChatOutlinedIcon,
    type: "static",
    external: true,
    visibleFor: ["user"],
  },

  // ===== 退会 =====
  {
    label: "退会",
    path: "/withdrawal",
    icon: PersonOffOutlinedIcon,
    type: "static",
    visibleFor: ["user"],
  },

  // ===== ログアウト =====
  {
    label: "ログアウト",
    icon: LogoutOutlinedIcon,
    type: "action",
    action: "logout",
    visibleFor: ["user", "company_employee"],
  },
];
